import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import { sto } from "../../../../../Context/InshData";
import { uri } from "../../../../../help/Api";
import HashLoader from "react-spinners/HashLoader";
import { colors, Container, Dialog, Modal } from "@material-ui/core";
import LoadingPage from "../../../../../services/LoadingPage";
import { useHistory, useLocation } from "react-router-dom";
import SadadInvoices from "./SadadInvoices";
const defaultAutos = {
  Branches: [],
};

export default function SadadInvoicesCon() {
  const locat = useLocation();
  const isPurches = locat.state.systemId == 0 ? true : false;
  const tb = {
    wait: true,
    Branches: true,
    Users: true,
    costcenters: true,
    UsersA: true,
    types: true,
    stor: sto,
    parms: {
      safe: -1,
      db_name: sto?.db_name
    },
  };
  const t = locat.state.systemId == 0 ? 2 : 1;

  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `/custm?t=${t}`
  } else {
    Urls = `/custm?t=${t}&&db_name=${sto?.db_name}`
  }
  const url = uri + "Auto" + Urls;
  const { data: CustomerOptions, fetching: fetchCust } = useFetchURL({
    ...{ url, dependencyArray: [] },
  });
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb,
  );

  if (
    fetchCust ||
    fetchAll ||
    CustomerOptions?.length == 0

  )
    return <LoadingPage />;

  return (
    <SadadInvoices
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        CustomerOptions: CustomerOptions?.length > 0 ? CustomerOptions : [],
        isPurches,
      }}
    />
  );
}
